module.exports = __webpack_public_path__ + "static/media/ex09.340c3234.mp3";